import vForms from "@olc/vforms/src/forms";
import * as Store from "./store";
import * as data from "./_data";
import { CMSAuth } from "./utils";
import { AppI18n } from "./plugins/i18n/AppI18n";
import axios from "./plugins/axios";

// eslint-disable-next-line func-names
export const create = (function () {
  let _store;
  let _i18n = null;
  const _appComponentsMap = new Map();

  return ({
    Vue,
    el,
    template,
    components = null,
    appId = null,
    libraries = [],
    storeModules = [],
    storePlugins = [],
    appGlobalStore = {},
    i18nOptions = {},
    vueObjectsFactory = () => ({}),
    vueProperties = {},
  }) => {
    if (appId) {
      const comp = _appComponentsMap.get(appId) || {};
      _appComponentsMap.set(appId, { ...comp, ...(components || {}) });
    }

    // Remove all script elements from template, and append them to the body element
    const script = template.getElementsByTagName("script");
    if (script) document.body.append(...Array.from(script));

    /* getElementById('top-of-page') - on WoM there is used id on HTML tag, but something fills on MP html id based on page */
    const elementId = el.substring(1);
    const htmlEl = document.getElementById(elementId);
    const initialData = {
      language: htmlEl.dataset.language,
    };

    if (!_store) {
      // permissions
      console.log("htmlEl.dataset.cmsPermissions:", htmlEl.dataset.cmsPermissions);
      window.cmsAuth = new CMSAuth(JSON.parse(htmlEl.dataset.cmsPermissions || "{}"));
      if (window.cmsAuth.hasDisableCache) {
        axios.defaults.headers = {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        };
      }

      // store
      _store = Store.create(initialData, storeModules, storePlugins, appGlobalStore);

      // translations
      Vue.use(AppI18n);
      const defaultI18nOptions = {
        locale: initialData.language,
        fallbackLocale: initialData.language,
        missing: (locale, key, vm) => key, // eslint-disable-line no-unused-vars
        messages: {
          [initialData.language]: {},
        },
      };
      _i18n = new AppI18n({
        ...defaultI18nOptions,
        ...i18nOptions,
      });

      Vue.use(vForms, {
        classPrefix: "cms-admin",
        i18n: _i18n,
      });
    }

    libraries.forEach((library) => {
      const { obj, libraryOpts } = library;

      if (typeof obj === "function") {
        Vue.use(obj, libraryOpts);
      } else {
        Vue.use(obj, libraryOpts);
      }
    });

    const vueKwargs = Object.fromEntries(
      libraries
        .filter((library) => library.isConstructor)
        .map((library) => {
          const { obj, constructorOpts } = library;
          // eslint-disable-next-line new-cap
          const instance = new obj({
            theme: { disable: true },
            ...constructorOpts,
          });

          return [library.instanceName, instance];
        })
    );
    const vue = new Vue({
      el,
      ...vueKwargs,
      components: _appComponentsMap.has(appId) ? _appComponentsMap.get(appId) : {},
      data: data.create({}),
      template: `
        <div id="${elementId}">${template.innerHTML}</div>`,
      store: _store,
      i18n: _i18n,
      ...vueObjectsFactory(),
    });

    Object.defineProperties(Vue.prototype, vueProperties);

    return vue;
  };
})();
